import {Component, Input, OnInit} from '@angular/core';
import {Filter} from '../../../models/warranties/filter.model';
import {HttpService} from '../../../services/http.service';
import {WarrantyList} from '../../../models/warranties/warranty-list.model';
import {ContractTypeDistinctModel} from '../../../models/warranties/contract-type-distinct.model';
import {DealerData} from '../../../models/Report/dealerData.modal';

@Component({
  selector: 'app-warrenty-summary',
  templateUrl: './warrenty-summary.component.html',
  styleUrls: ['./warrenty-summary.component.scss']
})
export class WarrentySummaryComponent implements OnInit {

  filter: Filter = new Filter();
  warrantyList: WarrantyList = new WarrantyList();
  warrantyName: any[] = [];
  contractTypes: ContractTypeDistinctModel[] = [];
  searchText = '';
  @Input()dealerName: any[] = [];
  dealerData: DealerData = new DealerData();

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.fetchContractTypes();
    this.refreshList();
  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      } else {
        this.filter.order = 'ASC';
      }
    }
    this.filter.orderBy = field;
    this.refreshList();
  }

  refreshList(){
    if (this.filter.dealerName === 'null'){
      this.filter.dealerName = null;
    }
    this.http.getWarrantyReport(this.filter).subscribe((res: WarrantyList) => {
      this.warrantyList = Object.assign(new WarrantyList(), res);
      res.dataList.forEach((x) => {
        this.warrantyName.push(x.contractType);
      });
    });
    this.http.getInvoice(this.filter).subscribe((res: DealerData) => {
      this.dealerData = Object.assign(new DealerData(), res);
    });
  }


  exportAsXLSX() {
    this.filter.pageSize = 999;
    this.http.downloadWarrantyReport(this.filter);
  }




  amount(invoice: any): string {
    const amount = invoice.total;
    return  `EUR ${amount}`;
  }
  showDirectionImage(): string {
    if (this.filter.orderBy === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  fetchContractTypes() {
    this.http.fetchDistinctContractTypes().subscribe((res) => {
      this.contractTypes = res;
    });
  }

  clearFilter() {
    this.filter = new Filter();
    this.refreshList();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.refreshList();
  }
}
